import { fetchCurrentUser } from '../../ducks/user.duck';
import { onGroupFolderCollectionCreate, onGroupFolderCollectionFind, onGroupFolderCollectionUpdate, onGroupFolderDocumentCollectionFind, onGroupFolderDocumentCollectionUpdate } from '../../util/api';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import {
  fetchSpaceList,
  getSpaceDetails,
  toggleCreateComment,
} from '../CircleCommunityPage/CircleCommunityPage.duck';

export const REQUEST_SPACE_DETAILS = 'app/MyGroupPage/REQUEST_SPACE_DETAILS';
export const SUCCESS_SPACE_DETAILS = 'app/MyGroupPage/SUCCESS_SPACE_DETAILS';
export const ERROR_SPACE_DETAILS = 'app/MyGroupPage/ERROR_SPACE_DETAILS';

export const CREATE_FOLDER_REQUEST = 'app/MyGroupPage/CREATE_FOLDER_REQUEST';
export const CREATE_FOLDER_SUCCESS = 'app/MyGroupPage/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_ERROR = 'app/MyGroupPage/CREATE_FOLDER_ERROR';

export const UPDATE_FOLDER_REQUEST = 'app/MyGroupPage/UPDATE_FOLDER_REQUEST';
export const UPDATE_FOLDER_SUCCESS = 'app/MyGroupPage/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_ERROR = 'app/MyGroupPage/UPDATE_FOLDER_ERROR';

export const FETCH_FOLDER_REQUEST = 'app/MyGroupPage/FETCH_FOLDER_REQUEST';
export const FETCH_FOLDER_SUCCESS = 'app/MyGroupPage/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_ERROR = 'app/MyGroupPage/FETCH_FOLDER_ERROR';

export const UPDATE_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_REQUEST';
export const UPDATE_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_SUCCESS';
export const UPDATE_FOLDER_DOCUMENT_ERROR = 'app/MyGroupPage/UPDATE_FOLDER_DOCUMENT_ERROR';

export const FETCH_FOLDER_DOCUMENT_REQUEST = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_REQUEST';
export const FETCH_FOLDER_DOCUMENT_SUCCESS = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_SUCCESS';
export const FETCH_FOLDER_DOCUMENT_ERROR = 'app/MyGroupPage/FETCH_FOLDER_DOCUMENT_ERROR';

const initialState = {
  requestSpaceDetails: false,
  spaceDetailsData: null,
  errorSpaceDetails: null,
  createFolderRequest: false,
  createFolderError: false,
  updateFolderRequest: false,
  updateFolderError: false,
  fetchFolderRequest: false,
  fetchFolderError: false,
  allGroupFolders: null,
  fetchFolderDocumentRequest: false,
  fetchFolderDocumentError: false,
  allFolderDocuments: null,
  updateFolderDocumentRequest: false,
  updateFolderDocumentError: false,
  totalDocumentCount: 0
};

export const FOLDER_DOCUMENT_PAGE_SIZE = 5;

export default function myGroupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: true };
    case SUCCESS_SPACE_DETAILS:
      return { ...state, requestSpaceDetails: false, spaceDetailsData: payload.data };
    case ERROR_SPACE_DETAILS:
      return {
        ...state,
        requestSpaceDetails: false,
        spaceDetailsData: null,
        errorSpaceDetails: payload.error,
      };

    case CREATE_FOLDER_REQUEST:
      return { ...state, createFolderRequest: payload, createFolderError: null };
    case CREATE_FOLDER_SUCCESS:
      return { ...state, createFolderRequest: false, createFolderError: null };
    case CREATE_FOLDER_ERROR:
      return {
        ...state,
        createFolderRequest: false,
        createFolderError: true,
      };

    case UPDATE_FOLDER_REQUEST:
      return { ...state, updateFolderRequest: payload, updateFolderError: null };
    case UPDATE_FOLDER_SUCCESS:
      return { ...state, updateFolderRequest: false, updateFolderError: null };
    case UPDATE_FOLDER_ERROR:
      return {
        ...state,
        updateFolderRequest: false,
        updateFolderError: true,
      };

    case FETCH_FOLDER_REQUEST:
      return { ...state, fetchFolderRequest: true, fetchFolderError: null };
    case FETCH_FOLDER_SUCCESS:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: null,
        allGroupFolders: payload.data,
        totalDocumentCount: payload.pagination.documentCount,
      };
    case FETCH_FOLDER_ERROR:
      return {
        ...state,
        fetchFolderRequest: false,
        fetchFolderError: true,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    case UPDATE_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state, updateFolderDocumentRequest: payload,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, updateFolderDocumentRequest: false,
        updateFolderDocumentError: false,
      };
    case UPDATE_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        updateFolderDocumentRequest: false,
        updateFolderDocumentError: true,
      };

    case FETCH_FOLDER_DOCUMENT_REQUEST:
      return {
        ...state,
        fetchFolderDocumentRequest: true,
        fetchFolderDocumentError: false,
        allFolderDocuments: null,
      };
    case FETCH_FOLDER_DOCUMENT_SUCCESS:
      return {
        ...state, fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: false,
        allFolderDocuments: payload,
      };
    case FETCH_FOLDER_DOCUMENT_ERROR:
      return {
        ...state,
        fetchFolderDocumentRequest: false,
        fetchFolderDocumentError: true,
        allFolderDocuments: null,
      };

    default:
      return state;
  }
}

export const requestSpaceDetails = () => ({
  type: REQUEST_SPACE_DETAILS,
});
export const successSpaceDetails = data => ({
  type: SUCCESS_SPACE_DETAILS,
  payload: { data },
});
export const errorSpaceDetails = error => ({
  type: ERROR_SPACE_DETAILS,
  payload: { error },
});


export const createFolderRequest = (data) => ({
  type: CREATE_FOLDER_REQUEST,
  payload: data,
});
export const createFolderSuccess = data => ({
  type: CREATE_FOLDER_SUCCESS,
  payload: data,
});
export const createFolderError = error => ({
  type: CREATE_FOLDER_ERROR,
  payload: error,
});

export const updateFolderRequest = (data) => ({
  type: UPDATE_FOLDER_REQUEST,
  payload: data,
});
export const updateFolderSuccess = data => ({
  type: UPDATE_FOLDER_SUCCESS,
  payload: data,
});
export const updateFolderError = error => ({
  type: UPDATE_FOLDER_ERROR,
  payload: error,
});

export const fetchFolderRequest = () => ({
  type: FETCH_FOLDER_REQUEST,
});
export const fetchFolderSuccess = data => ({
  type: FETCH_FOLDER_SUCCESS,
  payload: data,
});
export const fetchFolderError = error => ({
  type: FETCH_FOLDER_ERROR,
  payload: error,
});


export const fetchFolderDocumentRequest = () => ({
  type: FETCH_FOLDER_DOCUMENT_REQUEST,
});
export const fetchFolderDocumentSuccess = data => ({
  type: FETCH_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const fetchFolderDocumentError = error => ({
  type: FETCH_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const updateFolderDocumentRequest = (data) => ({
  type: UPDATE_FOLDER_DOCUMENT_REQUEST,
  payload: data,
});
export const updateFolderDocumentSuccess = data => ({
  type: UPDATE_FOLDER_DOCUMENT_SUCCESS,
  payload: data,
});
export const updateFolderDocumentError = error => ({
  type: UPDATE_FOLDER_DOCUMENT_ERROR,
  payload: error,
});

export const createGroupFolder = (params, groupId) => async (dispatch, getState) => {
  dispatch(createFolderRequest("create"));
  return onGroupFolderCollectionCreate(params)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: groupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(createFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(createFolderError(storableError(e)));
    });
};

export const updateGroupFolder = (params, groupId) => async (dispatch, getState) => {
  const type = !!params.payload.isDelete ? "delete" : "update"
  dispatch(updateFolderRequest(type));
  return onGroupFolderCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupFolder({
        payload: {
          groupId: groupId,
          isActive: true,
          isDelete: false
        }
      }))
      dispatch(updateFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderError(storableError(e)));
    });
};

export const fetchGroupFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderRequest());
  return onGroupFolderCollectionFind(params)
    .then((response) => {
      dispatch(fetchFolderSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderError(storableError(e)));
    });
};


export const updateGroupDocumentFolder = (params, fetchData) => async (dispatch, getState) => {
  dispatch(updateFolderDocumentRequest(params.id));
  return onGroupFolderDocumentCollectionUpdate(params)
    .then(async (response) => {
      await dispatch(fetchGroupDocumentFolder(fetchData))
      dispatch(updateFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(updateFolderDocumentError(storableError(e)));
    });
};

export const fetchGroupDocumentFolder = (params) => async (dispatch, getState) => {
  dispatch(fetchFolderDocumentRequest());
  return onGroupFolderDocumentCollectionFind(params)
    .then((response) => {
      dispatch(fetchFolderDocumentSuccess(response));
      return response;
    })
    .catch(e => {
      console.log(storableError(e), "createGroupFolder >>>> storableError(e)")
      dispatch(fetchFolderDocumentError(storableError(e)));
    });
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { page = 1 } = parse(search);
  const { currentUser } = getState().user;
  const { spaceListData } = getState().CircleCommunityPage;
  try {
    if (!currentUser) {
      await dispatch(fetchCurrentUser());
    }
  } catch (e) {
    console.log(e, '&&& &&& => e');
  }
  const promisify = [dispatch(getSpaceDetails({ spaceId: params.id, page: +page })), dispatch(toggleCreateComment(false)), dispatch(fetchGroupFolder({
    payload: {
      groupId: params.id,
      isActive: true,
      isDelete: false
    }
  }))];

  if (!spaceListData || (spaceListData && spaceListData.length == 0)) promisify.push(dispatch(fetchSpaceList()));

  return Promise.all(promisify);
};
